import { RowDataFastPass } from "../../components/FastPassHistoryPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be initialized with the FastPassTable factory
 */
class FastPassRow implements DataDisplayRowI {
    endpoint: string;
    method: 'GET' | 'POST';
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/membership/read-fast-pass-log"
        this.method = "GET"
        this.accessData = "history"
    }

    create(row: any): RowDataFastPass {
        const rowDataFastPass: RowDataFastPass = {
            log_id: row.log_id,
            fullname: row.fullname,
            created_at: row.createdAt,
            remark: row.remarks ?? "",
        };
        return rowDataFastPass;
    }
}

let fastPassRow: FastPassRow | null = null;

export default function getFastPassRow(): FastPassRow {
    if (fastPassRow === null)
        fastPassRow = new FastPassRow()
    return fastPassRow
}
